// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"bcv_a bfq_va bfq_rl bfq_wc"};